/**
 * Initializes scroll event listeners for the site header to adjust its position and styles
 * when the user scrolls up the page. This function makes the header stick to the top of the page
 * when scrolling up past a certain point, enhancing visibility and accessibility.
 *
 * Elements Affected:
 * - `.site-header`: Main header container.
 * - `.top-ribbon`: Top section of the header.
 * - `#topbar`: Top bar within the header.
 * - `.header-bottom`: Bottom section of the header.
 *
 * Scroll Logic:
 * - The header elements are fixed when the user scrolls up, starting when the scroll position is greater than 300px.
 * - Header elements return to their original state when the user scrolls down.
 */
const initScrollHeaderUp = () => {
  let lastScrollPosition = window.pageYOffset;
  const siteHeader = document.querySelector('.site-header');
  const topRibbon = siteHeader && siteHeader.querySelector('.top-ribbon');
  const topBar = siteHeader && siteHeader.querySelector('#topbar');
  const headerBottom = siteHeader && siteHeader.querySelector('.header-bottom');

  const isScrollingUp = () => {
    const currentScrollPosition = window.pageYOffset;
    const isScrollingUp = currentScrollPosition < lastScrollPosition && currentScrollPosition > 300;
    lastScrollPosition = currentScrollPosition;
    return isScrollingUp;
  }

  const getElementHeight = (element) => {
    return element.getBoundingClientRect().height;
  }

  window.addEventListener("scroll", () => {
    if (isScrollingUp()) {
      const topRibbonHeight = getElementHeight(topRibbon);
      const topBarHeight = getElementHeight(topBar);

      topRibbon.style.position = 'fixed';
      topRibbon.style.width = '100%';
      topRibbon.style.margin = '0';
      topRibbon.style.opacity = '1';
      topRibbon.style.transition = 'all 0.5s';
      topRibbon.style.background = 'white';
      topRibbon.style.top = '0';
      topBar.style.position = 'fixed';
      topBar.style.width = '100%';
      topBar.style.margin = '0';
      topBar.style.opacity = '1';
      topBar.style.transition = 'all 0.5s';
      topBar.style.top = `${topRibbonHeight}px`;
      headerBottom.style.position = 'fixed';
      headerBottom.style.width = '100%';
      headerBottom.style.margin = '0';
      headerBottom.style.opacity = '1';
      headerBottom.style.transition = 'all 0.5s';
      headerBottom.style.top = `${topRibbonHeight + topBarHeight}px`;
      headerBottom.style.zIndex = '9';
      headerBottom.style.background = 'white';
      headerBottom.style.webkitBoxShadow = '-1px 1px 9px -4px rgba(0, 0, 0, 0.75)';
      headerBottom.style.boxShadow = '-1px 1px 9px -4px #000000bf';

    } else {
      topBar.style.position = 'initial';
      topBar.style.top = 'unset';
      headerBottom.style.position = 'initial';
      headerBottom.style.top = 'unset';
      headerBottom.style.webkitBoxShadow = 'unset';
      headerBottom.style.boxShadow = 'unset';
    }
  });
}

export default initScrollHeaderUp;
